export default __webpack_public_path__ + "static/winter4-17cfaa3ea78bddc95a5749cc8218ba79.webp";